import React from 'react';
import 'react-app-polyfill/ie9';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import WrapApp from "./WrapApp";

ReactDOM.render(
    <React.StrictMode>
        <WrapApp />
    </React.StrictMode>,
    document.getElementById("root")
);
reportWebVitals();

